import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/router/routes/routes'
import onboardingRoutes from '@/router/routes/onboarding-routes'
import { setupRouterGuards } from './router-guards'
import unsubscribeRoutes from './routes/unsubscribe-route'

export const isOnboarding = () => {
  const subdomain = window.location.host.split('.')[0]
  return subdomain.includes('onboarding')
}

export const isUnsubscribe = () => {
  return window.location.href.includes('unsubscribe')
}

const currentRoutes = () => {
  if (isOnboarding() === true) {
    return onboardingRoutes
  } else if (isUnsubscribe() === true) {
    return unsubscribeRoutes
  } else {
    return routes
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: currentRoutes()
})

setupRouterGuards(router, isOnboarding())

export default router
